import { useQuery } from '@tanstack/react-query';
import authAxios from '@services/authAxios';
import { formatDate } from '@helpers/utils';
import { useFilters } from '../state/useFilters';

const useGetCPList = (params) => {
    const filters = useFilters();
    const { scheme, status, dateStart, dateEnd, searchParam, limit, sort, page } = params || {};
    const statusId = status ? status.map((s) => s.id) : undefined;
    const schemeId = scheme ? scheme.map((s) => s.id) : undefined;

    const apiParams = {
        promotion_name: searchParam || undefined,
        limit: limit || undefined,
        sort: sort || undefined,
        scheme: schemeId,
        status: statusId,
        start_date: dateStart ? formatDate(dateStart, 'YYYY-MM-DD') : undefined,
        end_date: dateEnd ? formatDate(dateEnd, 'YYYY-MM-DD') : undefined,
        page: page || 1,
    };

    return useQuery({
        queryKey: ['promotion-claim', params],
        queryFn: async () => {
            const { data } = await authAxios.get('/api/v1/promotion-claim', { params: apiParams });
            filters.set({
                total_page: data?.data?.total_page,
                total_data: data?.data?.total_data,
            });
            return data?.data;
        },
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 0,
        enabled: !!params,
        keepPreviousData: true,
    });
};

export default useGetCPList;
